{
  "public-appointment-details-page": {
    "buttons": {
      "book-new-appointment": "Prendre un nouveau rendez-vous",
      "cancel": "Annuler le rendez-vous"
    }
  }
}
